import { configureStore } from '@reduxjs/toolkit'
import userReducer from './slices/userSlice'
import cartReducer from './slices/cartSlice'
import dashboardReducer from './slices/dashboardSlice'
import orderReducer from './slices/orderSlice'
import pubsubReducer from './slices/pubsubSlice'

const store = configureStore({
    reducer: {
        user: userReducer,
        cart: cartReducer,
        dashboard: dashboardReducer,
        order: orderReducer,
        pubsub: pubsubReducer,
    },
})

export default store
